import React from "react";

function SearchArea() {
  return (
    <>
      <div class="search-wrap">
        <div class="search-inner">
          <i class="fas fa-times search-close" id="search-close"></i>
          <div class="search-cell">
            <form method="get">
              <div class="search-field-holder">
                <input
                  type="search"
                  class="main-search-input"
                  placeholder="Search..."
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default SearchArea;
